// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aiReviewContent .aiInterview_header {
  width: 100%;
  height: auto;
  flex-shrink: 0;
  border-radius: 6px;
  border: 1px solid #eaeaea;
  background: #fff;
  padding: 18px;
}
.aiReviewContent .aiInterview_header_div h3 {
  color: #000;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.aiReviewContent .aiInterview_header_div {
  display: grid;
  grid-template-columns: 75% 24%;
  column-gap: 10px;
}
.aiReviewContent .ai_left_header {
  color: #3a3939;
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 11px;
}
.aiReviewContent .ai_right_header {
  color: #3a3939;
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 11px;
}
.aiReviewContent .ai_level {
  color: #0a7f8f;
  font-family: Poppins;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.aiReviewContent .ai_interview_details {
  color: #535353;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  float: right;
}
.aiReviewContent .aiInterview_header button {
  color: #fff;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  flex-shrink: 0;
  border-radius: 4px;
  background: #0a7f8f;
  width: 121px;
  height: 37px;
}
.aiReviewContent .assessment_maindiv {
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid #ededed;
  background: #f8faff;
  padding: 18px;
}
.aiReviewContent .assessment_grid {
  display: grid;
  grid-template-columns: 24% 24% 24% 24%;
  column-gap: 12px;
}
.aiReviewContent .tabSwitchDiv {
  flex-shrink: 0;
  border-radius: 4px;
  background: #fff;
  padding: 10px;
  flex-grow: 1;
}
.aiReviewContent .assessment_card {
  flex-shrink: 0;
  border-radius: 4px;
  background: #fff;
  padding: 10px;
}
.aiReviewContent .assessment_card h4 {
  color: #0c2556;
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 138.462% */
  text-transform: capitalize;
}
.aiReviewContent .assessment_grid_auto {
  display: flex;
  column-gap: 12px;
}
.aiReviewContent .assessment_card_auto {
  flex-shrink: 0;
  border-radius: 4px;
  background: #fff;
  padding: 10px;
  flex-grow: 1;
}
.aiReviewContent .assessment_card_auto h4 {
  color: #0c2556;
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 138.462% */
  text-transform: capitalize;
}
.aiReviewContent .chart_div {
  text-align: center;
  display: grid;
  justify-items: center;
}
.aiReviewContent .infraction_count {
  color: #dd841d;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 50px;
}
.aiReviewContent .infraction_header {
  color: #000;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 50px;
}
.aiReviewContent .infraction_div {
  flex-shrink: 0;
  border-radius: 4px;
}
.aiReviewContent .infraction_div img {
  width: 100%;
  height: 90%;
}
.aiReviewContent .viewAll_infraction {
  color: #0a7f8f;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  text-decoration-line: underline;
  text-transform: capitalize;
  float: right;
  padding-right: 30px;
}
.aiReviewContent .resume_div {
  display: grid;
  grid-template-columns: 32% 32% 32%;
  column-gap: 15px;
  padding: 10px;
  padding-bottom: 45px;
}
.aiReviewContent .test_maindiv {
  display: grid;
  grid-template-columns: 32% 32% 32%;
  column-gap: 15px;
  row-gap: 15px;
}
.aiReviewContent .resume_div_img {
  width: 100%;
  height: 100%;
  border-radius: 6px;
}
.aiReviewContent .match_div {
  width: 100%;
  height: 400px;
  flex-shrink: 0;
  border-radius: 4px;
  background: #00c5b9;
}
.aiReviewContent .not_Match {
  width: 100%;
  height: 400px;
  flex-shrink: 0;
  border-radius: 4px;
  background: #f15e79;
}
.aiReviewContent .match_img {
  margin: auto;
  text-align: center;
  padding-top: 90px;
}
.aiReviewContent .not_Match h3 {
  color: #000;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px; /* 112.5% */
  text-transform: capitalize;
  text-align: center;
  padding-top: 10px;
}
.aiReviewContent .match_div h3 {
  color: #fff;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  text-transform: capitalize;
  text-align: center;
  padding-top: 45px;
}
.aiReviewContent .container {
  position: relative;
  text-align: center;
  color: white;
}
.aiReviewContent .bottom-right {
  position: absolute;
  bottom: 35px;
  right: 70px;
  font-size: 16px;
  font-weight: 600;
}
.aiReviewContent .text_maindiv {
  padding: 20px;
}
.aiReviewContent .text_maindiv ul {
  padding: 10px;
}
.aiReviewContent .text_maindiv li {
  color: #fff;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  text-transform: capitalize;
}
.aiReviewContent .resume_div h4 {
  color: #0c2556;
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 138.462% */
  text-transform: capitalize;
  padding: 12px;
  padding-left: 0;
}
.aiReviewContent .device_info {
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid #ebebeb;
  background: #fff;
  padding: 8px;
  display: grid;
  grid-template-columns: 90% 10%;
}
.aiReviewContent .testHeader {
  color: #a3aed0;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
  letter-spacing: -0.28px;
}
.aiReviewContent .test_data {
  color: #2b3674;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: -0.32px;
}
.aiReviewContent .scoreData {
  display: grid;
  grid-template-columns: auto auto;
  column-gap: 8px;
  padding: 2px;
  row-gap: 8px;
  text-align: center;
  width: 40%;
  margin: auto;
}
.aiReviewContent .ant-avatar img {
  object-fit: scale-down;
}
.aiReviewContent .scoreData li {
  color: #535353;
  font-family: Poppins;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  text-transform: capitalize;
}
.aiReviewContent .infraction_data {
  color: #0c2556;
  font-family: Poppins;
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px; /* 81.818% */
  text-transform: capitalize;
  text-align: center;
}
.aiReviewContent .dot {
  height: 8px;
  width: 8px;
  border-radius: 50%;
  display: inline-block;
}
.aiReviewContent .clarity {
  background-color: #086b79;
}
.aiReviewContent .fluency {
  background-color: #00bf63;
}
.aiReviewContent .grammar {
  background-color: #d1d605;
}
.aiReviewContent .vocabulary {
  background-color: #ff7171;
}
.aiReviewContent .coherence {
  background-color: #cb1cff;
}
.aiReviewContent .notAnswered {
  background-color: red;
}
.aiReviewContent .interview_feedback_info {
  margin: auto;
  background-color: #f8faff;
  border: 0.5px solid #dbdbdb;
  padding: 10px;
}
.aiReviewContent .header_name {
  color: #000;
  font-size: 18px;
  font-family: Poppins;
  font-weight: 600;
  line-height: 50px;
}
.aiReviewContent .feedBackContent {
  width: 100%;
  height: auto;
  flex-shrink: 0;
  border-radius: 4px;
  background: rgba(250, 250, 250, 0.33);
}
.aiReviewContent .feedbackContent_header {
  color: #0a7f8f;
  font-size: 16px;
  font-family: Poppins;
  font-weight: 600;
}
.aiReviewContent .avatar_div {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 4px;
  background: #ebf8fa;
  text-align: center;
  line-height: 2.6;
}
.aiReviewContent .ant-avatar img {
  object-fit: contain;
}
.aiReviewContent .bottom_banner {
  width: 100%;
  height: 65px;
  flex-shrink: 0;
  border-radius: 4px;
  background: #ebf8fa;
  bottom: 0;
  position: relative;
}
.aiReviewContent .progImg_div {
  height: 165px;
  position: relative;
  z-index: 1;
}
.aiReviewContent .left_header {
  color: #3a3939;
  font-size: 16px;
  font-family: "Poppins";
}
.aiReviewContent .right_data {
  color: #3a3939;
  font-size: 16px;
  font-family: "Poppins";
  font-weight: 600;
}
.aiReviewContent .question_p {
  color: #000;
  font-size: 16px;
  font-family: Poppins;
  text-transform: capitalize;
  font-weight: 600;
}
.aiReviewContent .answer_box {
  width: 90%;
  border-radius: 4px;
  border: 1px solid rgba(169, 169, 169, 0.42);
  padding: 4px;
  margin-top: 10px;
}
.aiReviewContent .vertical_maindiv {
  display: flex;
}
.aiReviewContent .vertical {
  padding-right: 25px;
  margin-top: 10px;
  font-family: "Poppins";
  font-weight: 14px;
  text-align: center;
  text-transform: capitalize;
}
.aiReviewContent .nonvertical_maindiv {
  margin-top: 10px;
}
.aiReviewContent .nonvertical {
  display: flex;
  margin-top: 10px;
  font-family: "Poppins";
  font-weight: 14px;
  text-transform: capitalize;
}
.aiReviewContent .save {
  width: 118px;
  height: 42px;
  background: #0a7f8f;
  border-radius: 4px;
  color: white;
}
.aiReviewContent .cancel {
  width: 118px;
  height: 42px;
}
.aiReviewContent input[type=radio] {
  accent-color: #0a7f8f;
}
.aiReviewContent .passBox {
  background-color: #e8fff3;
  width: 369px;
  height: 59px;
  flex-shrink: 0;
  margin: auto;
  padding: 20px;
  border-radius: 6px;
  margin-top: 20px;
}
.aiReviewContent .pass_span {
  color: #006932;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: capitalize;
  padding-left: 14px;
}
.aiReviewContent .passBox img {
  padding-left: 120px;
}
.aiReviewContent .onHoldBox {
  width: 369px;
  height: 59px;
  flex-shrink: 0;
  border-radius: 6px;
  background: #fff8dd;
  margin: auto;
  padding: 20px;
  margin-top: 20px;
}
.aiReviewContent .onHoldBox img {
  padding-left: 218px;
}
.aiReviewContent .onHold_span {
  color: #876b00;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: capitalize;
  padding-left: 14px;
}
.aiReviewContent .rejectBox {
  width: 369px;
  height: 59px;
  flex-shrink: 0;
  border-radius: 6px;
  background: #ffecec;
  margin: auto;
  padding: 20px;
  margin-top: 20px;
}
.aiReviewContent .rejectBox img {
  padding-left: 232px;
}
.aiReviewContent .rejectBox_span {
  color: #f45c5c;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: capitalize;
  padding-left: 14px;
}
.aiReviewContent .aiInterview_header {
  width: 100%;
  height: auto;
  flex-shrink: 0;
  border-radius: 6px;
  border: 1px solid #eaeaea;
  background: #fff;
  padding: 18px;
  margin-top: 10px;
}
.aiReviewContent .aiInterview_header_div h3 {
  color: #000;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.aiReviewContent .aiInterview_header_div {
  display: grid;
  grid-template-columns: 75% 24%;
  column-gap: 10px;
}
.aiReviewContent .ai_left_header {
  color: #3a3939;
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 11px;
}
.aiReviewContent .ai_right_header {
  color: #3a3939;
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 11px;
}
.aiReviewContent .ai_level {
  color: #0a7f8f;
  font-family: Poppins;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.aiReviewContent .ai_interview_details {
  color: #535353;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  float: right;
}
.aiReviewContent .aiInterview_header button {
  color: #fff;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  flex-shrink: 0;
  border-radius: 4px;
  background: #0a7f8f;
  width: 121px;
  height: 37px;
}
.aiReviewContent .aiInterview_header button.aiInterview_header_button {
  background-color: rgba(3, 165, 58, 0.1);
  border-radius: 55px;
  color: #0A8F4F;
  font-size: 14px;
  font-weight: 600;
}
.aiReviewContent .aiInterview_header button.interview_failed {
  color: #8f340a !important;
  background-color: rgba(165, 62, 3, 0.1) !important;
}
.aiReviewContent .aiInterview_header button.interview_moderate_fit {
  color: #F19331 !important;
  background-color: #f8f0e6 !important;
}
.aiReviewContent .closeButton {
  color: #fff;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  flex-shrink: 0;
  border-radius: 4px;
  background: #0a7f8f;
  width: 121px;
  height: 37px;
}
.aiReviewContent .camera_icons {
  font-size: xx-large;
  color: #00b165;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Assesments/assesment.scss"],"names":[],"mappings":"AACI;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EAEA,gBAAA;EACA,aAAA;AADN;AAII;EACE,WAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAFN;AAKI;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AAHN;AAMI;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAJN;AAOI;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AALN;AAQI;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AANN;AASI;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AAPN;AAUI;EAEE,WAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AARN;AAWI;EACE,WAAA;EACA,wBAAA;EAAA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;AATN;AAYI;EACE,aAAA;EACA,sCAAA;EACA,gBAAA;AAVN;AAaI;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;AAXN;AAcI;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AAZN;AAeI;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,0BAAA;AAbN;AAgBI;EACE,aAAA;EACA,gBAAA;AAdN;AAiBI;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;AAfN;AAkBI;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,0BAAA;AAhBN;AAmBI;EACE,kBAAA;EACA,aAAA;EACA,qBAAA;AAjBN;AAoBI;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAlBN;AAqBI;EACE,WAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAnBN;AAsBI;EACE,cAAA;EACA,kBAAA;AApBN;AAuBI;EACE,WAAA;EACA,WAAA;AArBN;AAwBI;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,+BAAA;EACA,0BAAA;EACA,YAAA;EACA,mBAAA;AAtBN;AAyBI;EACE,aAAA;EACA,kCAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;AAvBN;AA0BI;EACE,aAAA;EACA,kCAAA;EACA,gBAAA;EACA,aAAA;AAxBN;AA2BI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAzBN;AA4BI;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AA1BN;AA6BI;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AA3BN;AA8BI;EAGE,YAAA;EACA,kBAAA;EACA,iBAAA;AA9BN;AAgCI;EACE,WAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;AA9BN;AAiCI;EACE,WAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;AA/BN;AAkCI;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;AAhCN;AAmCI;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAjCN;AAoCI;EACE,aAAA;AAlCN;AAoCI;EACE,aAAA;AAlCN;AAqCI;EACE,WAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,0BAAA;AAnCN;AAsCI;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,0BAAA;EACA,aAAA;EACA,eAAA;AApCN;AAuCI;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;AArCN;AAwCI;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,uBAAA;AAtCN;AAyCI;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AAvCN;AA0CI;EACE,aAAA;EACA,gCAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;AAxCN;AA2CI;EACE,sBAAA;AAzCN;AA4CI;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;AA1CN;AA6CI;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,YAAA;EACA,0BAAA;EACA,kBAAA;AA3CN;AA8CI;EACE,WAAA;EACA,UAAA;EACA,kBAAA;EACA,qBAAA;AA5CN;AA+CI;EACE,yBAAA;AA7CN;AAgDI;EACE,yBAAA;AA9CN;AAiDI;EACE,yBAAA;AA/CN;AAkDI;EACE,yBAAA;AAhDN;AAmDI;EACE,yBAAA;AAjDN;AAoDI;EACE,qBAAA;AAlDN;AAqDI;EAEE,YAAA;EACA,yBAAA;EACA,2BAAA;EACA,aAAA;AApDN;AAuDI;EACE,WAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;AArDN;AAwDI;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EAEA,qCAAA;AAvDN;AA2DI;EACE,cAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;AAzDN;AA4DI;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AA1DN;AA6DI;EACE,mBAAA;AA3DN;AA8DI;EACE,WAAA;EACA,YAAA;EAEA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AA7DN;AAgEI;EACE,aAAA;EACA,kBAAA;EACA,UAAA;AA9DN;AAiEI;EACE,cAAA;EACA,eAAA;EACA,sBAAA;AA/DN;AAkEI;EACE,cAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;AAhEN;AAmEI;EACE,WAAA;EACA,eAAA;EACA,oBAAA;EACA,0BAAA;EAEA,gBAAA;AAlEN;AAqEI;EACE,UAAA;EACA,kBAAA;EACA,2CAAA;EACA,YAAA;EACA,gBAAA;AAnEN;AAqEI;EACE,aAAA;AAnEN;AAsEI;EAEE,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;AArEN;AAwEI;EACE,gBAAA;AAtEN;AAyEI;EACE,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,0BAAA;AAvEN;AA0EI;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AAxEN;AA2EI;EACE,YAAA;EAEA,YAAA;AAzEN;AA4EI;EACE,qBAAA;AA1EN;AA6EI;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AA3EN;AA8EI;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;AA5EN;AA+EI;EACE,mBAAA;AA7EN;AAgFI;EACE,YAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AA9EN;AAiFI;EACE,mBAAA;AA/EN;AAkFI;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;AAhFN;AAmFI;EACE,YAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AAjFN;AAoFI;EACE,mBAAA;AAlFN;AAqFI;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;AAnFN;AAsFI;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EAEA,gBAAA;EACA,aAAA;EACA,gBAAA;AArFN;AAwFI;EACE,WAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAtFN;AAyFI;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AAvFN;AA0FI;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAxFN;AA2FI;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAzFN;AA4FI;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA1FN;AA6FI;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AA3FN;AA8FI;EAEE,WAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AA5FN;AA+FI;EACE,uCAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA7FN;AAgGI;EACE,yBAAA;EACA,kDAAA;AA9FN;AAgGI;EACE,yBAAA;EACA,oCAAA;AA9FN;AAiGI;EAEE,WAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AA/FN;AAkGI;EACE,mBAAA;EACA,cAAA;AAhGN","sourcesContent":[".aiReviewContent {\n    .aiInterview_header {\n      width: 100%;\n      height: auto;\n      flex-shrink: 0;\n      border-radius: 6px;\n      border: 1px solid #eaeaea;\n      // background: #f8faff;\n      background: #fff;\n      padding: 18px;\n    }\n  \n    .aiInterview_header_div h3 {\n      color: #000;\n      font-family: Poppins;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n    }\n  \n    .aiInterview_header_div {\n      display: grid;\n      grid-template-columns: 75% 24%;\n      column-gap: 10px;\n    }\n  \n    .ai_left_header {\n      color: #3a3939;\n      font-family: Poppins;\n      font-size: 13px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 11px;\n    }\n  \n    .ai_right_header {\n      color: #3a3939;\n      font-family: Poppins;\n      font-size: 13px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 11px;\n    }\n  \n    .ai_level {\n      color: #0a7f8f;\n      font-family: Poppins;\n      font-size: 15px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: normal;\n    }\n  \n    .ai_interview_details {\n      color: #535353;\n      font-family: Poppins;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      float: right;\n    }\n  \n    .aiInterview_header button {\n      flex-shrink: 0;\n      color: #fff;\n      font-family: Poppins;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 600;\n      flex-shrink: 0;\n      border-radius: 4px;\n      background: #0a7f8f;\n      width: 121px;\n      height: 37px;\n    }\n  \n    .assessment_maindiv {\n      width: 100%;\n      height: fit-content;\n      flex-shrink: 0;\n      border-radius: 4px;\n      border: 1px solid #ededed;\n      background: #f8faff;\n      padding: 18px;\n    }\n  \n    .assessment_grid {\n      display: grid;\n      grid-template-columns: 24% 24% 24% 24%;\n      column-gap: 12px;\n    }\n  \n    .tabSwitchDiv {\n      flex-shrink: 0;\n      border-radius: 4px;\n      background: #fff;\n      padding: 10px;\n      flex-grow: 1;\n    }\n  \n    .assessment_card {\n      flex-shrink: 0;\n      border-radius: 4px;\n      background: #fff;\n      padding: 10px;\n    }\n  \n    .assessment_card h4 {\n      color: #0c2556;\n      font-family: Poppins;\n      font-size: 13px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 18px; /* 138.462% */\n      text-transform: capitalize;\n    }\n  \n    .assessment_grid_auto {\n      display: flex;\n      column-gap: 12px;\n    }\n  \n    .assessment_card_auto {\n      flex-shrink: 0;\n      border-radius: 4px;\n      background: #fff;\n      padding: 10px;\n      flex-grow: 1;\n    }\n  \n    .assessment_card_auto h4 {\n      color: #0c2556;\n      font-family: Poppins;\n      font-size: 13px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 18px; /* 138.462% */\n      text-transform: capitalize;\n    }\n  \n    .chart_div {\n      text-align: center;\n      display: grid;\n      justify-items: center;\n    }\n  \n    .infraction_count {\n      color: #dd841d;\n      font-family: Poppins;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 50px;\n    }\n  \n    .infraction_header {\n      color: #000;\n      font-family: Poppins;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 50px;\n    }\n  \n    .infraction_div {\n      flex-shrink: 0;\n      border-radius: 4px;\n    }\n  \n    .infraction_div img {\n      width: 100%;\n      height: 90%;\n    }\n  \n    .viewAll_infraction {\n      color: #0a7f8f;\n      font-family: Poppins;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 500;\n      text-decoration-line: underline;\n      text-transform: capitalize;\n      float: right;\n      padding-right: 30px;\n    }\n  \n    .resume_div {\n      display: grid;\n      grid-template-columns: 32% 32% 32%;\n      column-gap: 15px;\n      padding: 10px;\n      padding-bottom: 45px;\n    }\n  \n    .test_maindiv {\n      display: grid;\n      grid-template-columns: 32% 32% 32%;\n      column-gap: 15px;\n      row-gap: 15px;\n    }\n  \n    .resume_div_img {\n      width: 100%;\n      height: 100%;\n      border-radius: 6px;\n    }\n  \n    .match_div {\n      width: 100%;\n      height: 400px;\n      flex-shrink: 0;\n      border-radius: 4px;\n      background: #00c5b9;\n    }\n  \n    .not_Match {\n      width: 100%;\n      height: 400px;\n      flex-shrink: 0;\n      border-radius: 4px;\n      background: #f15e79;\n    }\n  \n    .match_img {\n      // width: 80%;\n      // height: 50%;\n      margin: auto;\n      text-align: center;\n      padding-top: 90px;\n    }\n    .not_Match h3 {\n      color: #000;\n      font-family: Poppins;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 18px; /* 112.5% */\n      text-transform: capitalize;\n      text-align: center;\n      padding-top: 10px;\n    }\n  \n    .match_div h3 {\n      color: #fff;\n      font-family: Poppins;\n      font-size: 20px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 18px;\n      text-transform: capitalize;\n      text-align: center;\n      padding-top: 45px;\n    }\n  \n    .container {\n      position: relative;\n      text-align: center;\n      color: white;\n    }\n  \n    .bottom-right {\n      position: absolute;\n      bottom: 35px;\n      right: 70px;\n      font-size: 16px;\n      font-weight: 600;\n    }\n  \n    .text_maindiv {\n      padding: 20px;\n    }\n    .text_maindiv ul {\n      padding: 10px;\n    }\n  \n    .text_maindiv li {\n      color: #fff;\n      font-family: Poppins;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 16px; /* 133.333% */\n      text-transform: capitalize;\n    }\n  \n    .resume_div h4 {\n      color: #0c2556;\n      font-family: Poppins;\n      font-size: 13px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 18px; /* 138.462% */\n      text-transform: capitalize;\n      padding: 12px;\n      padding-left: 0;\n    }\n  \n    .device_info {\n      flex-shrink: 0;\n      border-radius: 4px;\n      border: 1px solid #ebebeb;\n      background: #fff;\n      padding: 8px;\n      display: grid;\n      grid-template-columns: 90% 10%;\n    }\n  \n    .testHeader {\n      color: #a3aed0;\n      font-family: Poppins;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 24px; /* 171.429% */\n      letter-spacing: -0.28px;\n    }\n  \n    .test_data {\n      color: #2b3674;\n      font-family: Poppins;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 600;\n      letter-spacing: -0.32px;\n    }\n  \n    .scoreData {\n      display: grid;\n      grid-template-columns: auto auto;\n      column-gap: 8px;\n      padding: 2px;\n      row-gap: 8px;\n      text-align: center;\n      width: 40%;\n      margin: auto;\n    }\n  \n    .ant-avatar img {\n      object-fit: scale-down;\n    }\n  \n    .scoreData li {\n      color: #535353;\n      font-family: Poppins;\n      font-size: 10px;\n      font-style: normal;\n      font-weight: 400;\n      text-transform: capitalize;\n    }\n  \n    .infraction_data {\n      color: #0c2556;\n      font-family: Poppins;\n      font-size: 22px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 18px; /* 81.818% */\n      text-transform: capitalize;\n      text-align: center;\n    }\n  \n    .dot {\n      height: 8px;\n      width: 8px;\n      border-radius: 50%;\n      display: inline-block;\n    }\n  \n    .clarity {\n      background-color: #086b79;\n    }\n  \n    .fluency {\n      background-color: #00bf63;\n    }\n  \n    .grammar {\n      background-color: #d1d605;\n    }\n  \n    .vocabulary {\n      background-color: #ff7171;\n    }\n  \n    .coherence {\n      background-color: #cb1cff;\n    }\n  \n    .notAnswered {\n      background-color: red;\n    }\n  \n    .interview_feedback_info {\n      // width: 65%;\n      margin: auto;\n      background-color: #f8faff;\n      border: 0.5px solid #dbdbdb;\n      padding: 10px;\n    }\n  \n    .header_name {\n      color: #000;\n      font-size: 18px;\n      font-family: Poppins;\n      font-weight: 600;\n      line-height: 50px;\n    }\n  \n    .feedBackContent {\n      width: 100%;\n      height: auto;\n      flex-shrink: 0;\n      border-radius: 4px;\n      // border: 0.5px solid #dbdbdb;\n      background: rgba(250, 250, 250, 0.33);\n      // padding: 20px;\n    }\n  \n    .feedbackContent_header {\n      color: #0a7f8f;\n      font-size: 16px;\n      font-family: Poppins;\n      font-weight: 600;\n    }\n  \n    .avatar_div {\n      width: 40px;\n      height: 40px;\n      flex-shrink: 0;\n      border-radius: 4px;\n      background: #ebf8fa;\n      text-align: center;\n      line-height: 2.6;\n    }\n  \n    .ant-avatar img {\n      object-fit: contain;\n    }\n  \n    .bottom_banner {\n      width: 100%;\n      height: 65px;\n      // transform: rotate(-90deg);\n      flex-shrink: 0;\n      border-radius: 4px;\n      background: #ebf8fa;\n      bottom: 0;\n      position: relative;\n    }\n  \n    .progImg_div {\n      height: 165px;\n      position: relative;\n      z-index: 1;\n    }\n  \n    .left_header {\n      color: #3a3939;\n      font-size: 16px;\n      font-family: 'Poppins';\n    }\n  \n    .right_data {\n      color: #3a3939;\n      font-size: 16px;\n      font-family: 'Poppins';\n      font-weight: 600;\n    }\n  \n    .question_p {\n      color: #000;\n      font-size: 16px;\n      font-family: Poppins;\n      text-transform: capitalize;\n      //padding-bottom: 10px;\n      font-weight: 600;\n    }\n  \n    .answer_box {\n      width: 90%;\n      border-radius: 4px;\n      border: 1px solid rgba(169, 169, 169, 0.42);\n      padding: 4px;\n      margin-top: 10px;\n    }\n    .vertical_maindiv {\n      display: flex;\n    }\n  \n    .vertical {\n      // display: flex;\n      padding-right: 25px;\n      margin-top: 10px;\n      font-family: 'Poppins';\n      font-weight: 14px;\n      text-align: center;\n      text-transform: capitalize;\n    }\n  \n    .nonvertical_maindiv {\n      margin-top: 10px;\n    }\n  \n    .nonvertical {\n      display: flex;\n      margin-top: 10px;\n      font-family: 'Poppins';\n      font-weight: 14px;\n      text-transform: capitalize;\n    }\n  \n    .save {\n      width: 118px;\n      height: 42px;\n      background: #0a7f8f;\n      border-radius: 4px;\n      color: white;\n    }\n  \n    .cancel {\n      width: 118px;\n      height: 42px;\n      height: 42px;\n    }\n  \n    input[type='radio'] {\n      accent-color: #0a7f8f;\n    }\n  \n    .passBox {\n      background-color: #e8fff3;\n      width: 369px;\n      height: 59px;\n      flex-shrink: 0;\n      margin: auto;\n      padding: 20px;\n      border-radius: 6px;\n      margin-top: 20px;\n    }\n  \n    .pass_span {\n      color: #006932;\n      font-family: Poppins;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n      text-transform: capitalize;\n      padding-left: 14px;\n    }\n  \n    .passBox img {\n      padding-left: 120px;\n    }\n  \n    .onHoldBox {\n      width: 369px;\n      height: 59px;\n      flex-shrink: 0;\n      border-radius: 6px;\n      background: #fff8dd;\n      margin: auto;\n      padding: 20px;\n      margin-top: 20px;\n    }\n  \n    .onHoldBox img {\n      padding-left: 218px;\n    }\n  \n    .onHold_span {\n      color: #876b00;\n      font-family: Poppins;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n      text-transform: capitalize;\n      padding-left: 14px;\n    }\n  \n    .rejectBox {\n      width: 369px;\n      height: 59px;\n      flex-shrink: 0;\n      border-radius: 6px;\n      background: #ffecec;\n      margin: auto;\n      padding: 20px;\n      margin-top: 20px;\n    }\n  \n    .rejectBox img {\n      padding-left: 232px;\n    }\n  \n    .rejectBox_span {\n      color: #f45c5c;\n      font-family: Poppins;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n      text-transform: capitalize;\n      padding-left: 14px;\n    }\n  \n    .aiInterview_header {\n      width: 100%;\n      height: auto;\n      flex-shrink: 0;\n      border-radius: 6px;\n      border: 1px solid #eaeaea;\n      // background: #f8faff;\n      background: #fff;\n      padding: 18px;\n      margin-top: 10px;\n    }\n  \n    .aiInterview_header_div h3 {\n      color: #000;\n      font-family: Poppins;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n    }\n  \n    .aiInterview_header_div {\n      display: grid;\n      grid-template-columns: 75% 24%;\n      column-gap: 10px;\n    }\n  \n    .ai_left_header {\n      color: #3a3939;\n      font-family: Poppins;\n      font-size: 13px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 11px;\n    }\n  \n    .ai_right_header {\n      color: #3a3939;\n      font-family: Poppins;\n      font-size: 13px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 11px;\n    }\n  \n    .ai_level {\n      color: #0a7f8f;\n      font-family: Poppins;\n      font-size: 15px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: normal;\n    }\n  \n    .ai_interview_details {\n      color: #535353;\n      font-family: Poppins;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      float: right;\n    }\n  \n    .aiInterview_header button {\n      flex-shrink: 0;\n      color: #fff;\n      font-family: Poppins;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 600;\n      flex-shrink: 0;\n      border-radius: 4px;\n      background: #0a7f8f;\n      width: 121px;\n      height: 37px;\n    }\n  \n    .aiInterview_header button.aiInterview_header_button {\n      background-color: rgba(3, 165, 58, 0.10);\n      border-radius: 55px;\n      color: #0A8F4F;\n      font-size: 14px;\n      font-weight: 600;\n    }\n  \n    .aiInterview_header button.interview_failed {\n      color: #8f340a !important;\n      background-color: rgba(165, 62, 3, 0.1) !important;\n    }\n    .aiInterview_header button.interview_moderate_fit {\n      color: #F19331 !important;\n      background-color: #f8f0e6 !important;\n    }\n  \n    .closeButton {\n      flex-shrink: 0;\n      color: #fff;\n      font-family: Poppins;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 600;\n      flex-shrink: 0;\n      border-radius: 4px;\n      background: #0a7f8f;\n      width: 121px;\n      height: 37px;\n    }\n  \n    .camera_icons {\n      font-size: xx-large;\n      color: #00b165;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
